import { memo } from 'react'

interface VideoCardSkeletonProps {
  count?: number
}

const VideoCardSkeleton = memo(function VideoCardSkeleton({ count = 1 }: VideoCardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="video-card skeleton">
          <div className="thumbnail-container">
            <div 
              className="thumbnail skeleton-bg" 
              style={{ 
                background: 'linear-gradient(90deg, var(--card-bg) 0%, var(--card-hover) 50%, var(--card-bg) 100%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 1.5s infinite',
              }}
            />
          </div>
          <div className="video-info" style={{ padding: '12px' }}>
            <div 
              className="skeleton-text" 
              style={{ 
                height: '16px', 
                width: '85%',
                borderRadius: '4px',
                background: 'var(--card-hover)',
                marginBottom: '8px',
              }}
            />
            <div 
              className="skeleton-text" 
              style={{ 
                height: '12px', 
                width: '60%',
                borderRadius: '4px',
                background: 'var(--card-hover)',
              }}
            />
          </div>
        </div>
      ))}
    </>
  )
})

export default VideoCardSkeleton
